import React from "react";
import classes from "./About.module.css";
import emojy7 from "../assets/images/emojy/emojy7.png";
import SkillBox from "../components/skillBox/SkillBox";
import HistoryBox from "../components/historyBox/HistoryBox";
import SkillCircle from "../components/skillCircle/SkillCircle";
const AboutPage = () => {
  return (
    <div>
      <h2 className={classes["title"]}>ABOUT ME</h2>
      <div className={classes["section-box"]}>
        <div className={classes["introduce-box"]}>
          안녕하세요! 저는 웹 개발자 황영걸입니다.
          <br />
          제가 가장 중요하게 생각하는 것은 <strong>지속적인 성장</strong>입니다.
          <br />
          항상 배우고 성장하는 것을 중요하게 생각하며, 끊임없이 발전하고 있습니다.
          <br />
          배움을 통해 더 깊이 있는 기술을 익히고, 그 기술을 바탕으로 <strong>더 나은 웹 환경을 제공하는 개발자</strong>가 되고자 합니다.
          <br />
          계속해서 성장하며, 더 나은 웹 서비스를 만들기 위해 노력하겠습니다.
          <br />
          감사합니다!
        </div>
        <div className={classes["introduce-img-box"]}>
          <img src={emojy7} />
        </div>
      </div>
      <div className={classes["section-box"]}>
        <SkillBox />
      </div>
      <div className={classes["section-box"]}>
        <SkillCircle />
      </div>

      <div className={classes["section-box"]}>
        <HistoryBox />
      </div>
    </div>
  );
};

export default AboutPage;
